"use client";

import { c as _c } from "react/compiler-runtime";
import type { MemesQuickVoteStats } from "@/hooks/memesQuickVote.helpers";
import { useMemesQuickVoteSummary } from "@/hooks/useMemesQuickVoteSummary";
type MemesWaveFooterStats = MemesQuickVoteStats & {
  readonly isReady: boolean;
};
const EMPTY_STATS: MemesWaveFooterStats = {
  uncastPower: null,
  unratedCount: 0,
  votingLabel: null,
  isReady: false
};
export const useMemesWaveFooterStats = () => {
  const $ = _c(2);
  const {
    stats
  } = useMemesQuickVoteSummary();
  if (typeof stats.uncastPower !== "number" || stats.unratedCount <= 0) {
    return EMPTY_STATS;
  }
  let t0;
  if ($[0] !== stats) {
    t0 = {
      ...stats,
      isReady: true
    };
    $[0] = stats;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};